import React from 'react';
import Form from '@quintoandar/cozy-core/Form';
import Input from '@quintoandar/cozy-core/Input/Input';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';

import { withRouter } from 'react-router';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { PROPERTY_DESCRIPTION_MAX_LENGTH } from './constants';

export const onChange = ({ onChangeItem, section, itemSlug, previousValue }) => (event) => {
  const value = event.target.value.length;
  if (value.length > PROPERTY_DESCRIPTION_MAX_LENGTH) {
    return;
  }
  onChangeItem({
    section,
    itemSlug,
    value: event.target.value,
    previousValue,
  });
};

export const PropertyDescriptionInput = ({
  onChangeItem,
  section,
  intl,
}) => (
  <Box mt={3}>
    <Typography level="bodyStrong">
      {section.propertyDescription.items.descricaoImovel.label}
    </Typography>
    <Form>
      <Input
        name="propertyDescription"
        label={section.propertyDescription.items.descricaoImovel.label}
        value={section.propertyDescription.items.descricaoImovel.value}
        placeholder={intl.formatMessage(messages.propertyDescriptionPlaceholder)}
        withCounter
        fullWidth
        multiline
        onChange={onChange({
          onChangeItem,
          section: 'propertyDescription',
          itemSlug: 'descricaoImovel',
          previousValue: section.propertyDescription.items.descricaoImovel.value,
        })}
        maxLength={PROPERTY_DESCRIPTION_MAX_LENGTH}
      />
    </Form>
  </Box>
);

PropertyDescriptionInput.propTypes = {
  onChangeItem: PropTypes.func,
  intl: PropTypes.object,
  section: PropTypes.shape(),
};

export default compose(
  withRouter,
  injectIntl,
)(PropertyDescriptionInput);

